import registrationInstance from '../instance'

const fetchPositions = () => {
  return registrationInstance.get('/users/positions')
}

export default fetchPositions
